import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination]);

window.VegasCarousel = {
	init: function () {
		let $carousels = $('.swiper-container');

		if ($carousels.length) {
			$carousels.each(function () {
				VegasCarousel.carousel($(this))
			});
		}
	},

	carousel: function ($self) {
		let slidesPerView = $self.data('items') || 1,
			slidesPerGroup = $self.data('per-group') || 1,
			spaceBetween = $self.data('margin') || 0,
			dots = !!$self.data('dots') || false,
			dynamicBullets = !!$self.data('dots-dynamic') || false,
			progressbarOpposite = !!$self.data('dots-progress') || false,
			dynamicMainBullets = $self.data('dots-cnt') || 1,
			nav = !!$self.data('nav') || false,
			direction = $self.data('direction') || 'horizontal',
			event = $self.data('event') || 'none',
			height = $self.data('height') || 'auto',
			loop = !!$self.data('loop') || false,
			mousewheel = !!$self.data('mousewheel') || false,
			simulateTouch = $self.attr('data-touch-mouse') !== 'false',
			setWrapperSize = !!$self.data('wrapper-size') || false,
			width = $self.data('width') || false,
			centeredSlides =!!$self.data('wrapper-size') || false,
			breakpoints = {
				0: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 0,
					autoHeight: true,
					simulateTouch: simulateTouch
				},
				768: {
					slidesPerView: 1,
					spaceBetween: spaceBetween
				},
				992: {
					slidesPerView: 1,
					spaceBetween: spaceBetween
				},
				1200: {
					slidesPerView: slidesPerView,
					spaceBetween: spaceBetween
				}
			};

		let $container = $self;

		let pagination = {};
		if (dots) {
			pagination = {
				pagination: {
					el: $container.children('.swiper-pagination')[0],
					type: 'bullets',
					clickable: true,
					progressbarOpposite: progressbarOpposite,
				},
			}

			if (dynamicBullets) {
				pagination.pagination.dynamicBullets = dynamicBullets;
				pagination.pagination.dynamicMainBullets = dynamicMainBullets;
			}
		}

		let navigation = {};
		if (nav) {
			navigation = {
				navigation: {
					nextEl: $container.children('.swiper-button-next')[0],
					prevEl: $container.children('.swiper-button-prev')[0],
				}
			}
		}

		// Частичные настройки не должны затирать отступы и остальные параметры брейкпоинта.
		let xs = $self.data('xs') || false; // 0px
		if (xs) breakpoints[0] = $.extend({}, breakpoints[0], xs);

		let md = $self.data('md') || false; // 768px
		if (md) breakpoints[768] = $.extend({}, breakpoints[768], md);

		let lg = $self.data('lg') || false; // 992px
		if (lg) breakpoints[992] = $.extend({}, breakpoints[992], lg);

		let wrapper = {};
		if (setWrapperSize) {
			wrapper = {
				setWrapperSize: setWrapperSize
			};
		}
		if (width) {
			wrapper = {
				width: width
			};
		}

		let options = {
			slidesPerGroup: slidesPerGroup,
			direction: direction,
			height: height,
			loop: loop,
			mousewheel: mousewheel,
			simulateTouch: simulateTouch,
			// Следим за реальной шириной контейнера, а не только за событием resize окна.
			resizeObserver: true,
			watchOverflow: true,
			breakpoints: breakpoints,
			centeredSlides: centeredSlides,
		};

		options = $.extend(options, pagination, navigation, wrapper);

		let swiper = new Swiper($self[0], options);
		VegasCarousel.events(swiper, event);
	},

	events: function (self, event) {
		let $container = $(self.$el);
		if (event === 'dots-hover') {
			let $bullets = $container.find('.swiper-pagination-bullet'),
				$link = $container.closest('.vg-shop-prd').find('.prd-link');

			$bullets.hover(function () {
				self.slideTo($(this).index());
			});

			$bullets.click(function () {
				location.href = $link.attr('href');
			})
		}
	}
}
